import React, { useEffect, useState } from 'react';
import authService from '../../../Services/authService';
import { useCart } from "../../../Services/CartContext";
import { useNavigate } from "react-router-dom";
import QuantityControlButton from '../Order/QuantityControlButton';
import { Link, useLocation } from "react-router-dom";

// ✅ TestCard component
const TestCard = ({ id, title, description, price, visit_type, quantity ,category_name,mrp_price}) => {
  const formattedPrice = typeof price === "string" ? Number.parseInt(price.replace("₹", "")) : price;

  return (
    <div className="bg-white p-4 rounded-2xl hover:shadow-sm transition-shadow border border-[#E0E0E0] hover:border-[#951C25]/30">
      <Link to={'/' + encodeURIComponent(category_name.replace(/ /g, '-')) + '/' + encodeURIComponent(title.replace(/ /g, '-')) + '-' + id} className="block mb-3">
        <h3 className="text-base font-medium text-[#4A4A4A] mb-2 line-clamp-2 min-h-[2.5rem]">{title}</h3>
        <p className="text-xs text-[#4A4A4A]/70 mb-2 line-clamp-3 min-h-[3rem]">{description}</p>
      </Link>
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-[#951C25]">₹{formattedPrice} <span className="line-through text-gray-500 ml-1">₹{mrp_price}</span></span>
        <QuantityControlButton
          id={id}
          name={title}
          price={formattedPrice}
          variant="simple"
          className="text-xs"
          visit_type={visit_type}
          quantity={quantity}
        />
      </div>
    </div>
  );
};

// ✅ PopularTests main component
const PopularTests = () => {
  const [popularTests, setPopularTests] = useState([]);
  const [cartItems, setCartItems] = useState([]);

  useEffect(() => {
    loadPopularTests();
    const user = authService.getCurrentuser();
    if (user) {
      loadCartItems();
    }
  }, []);

  const loadCartItems = () => {
    const token = authService.getCurrentUsertoken();
    const url = new URL(authService.getApiUrl() + 'cartlist');
    fetch(url, {
      method: 'POST',
      body: JSON.stringify({
        user_id: authService.getCurrentuser().id,
        organization_id: 1
      }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        if (res.status === 401) {
          authService.clientlogout();
          window.location.href = "/login";
        } else {
          return res.json();
        }
      })
      .then((result) => {
        const cartItems = result.data;
        setCartItems(cartItems);
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const loadPopularTests = () => {
    const url = new URL(authService.getApiUrl() + 'populartest');
    fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setPopularTests(result.data || []);
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const getQuantityForTest = (testId) => {
    const foundItem = cartItems.find((item) => item.test_id === testId);
    return foundItem ? foundItem.quantity : 0;
  };

  return (
    <section className="py-10 md:py-14 bg-[#F5F5F7]">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="text-3xl font-semibold text-[#4A4A4A] mb-8 text-center">
          Popular <span className="text-[#951C25]">Health Tests</span>
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {popularTests && popularTests.length > 0 && popularTests.map((test) => (
            <TestCard
              key={test.id}
              id={test.id}           // ✅ pass real id
              title={test.test_name}
              description={test.short_description}
              price={test.price}
              visit_type={test.visit_type}
              quantity={getQuantityForTest(test.id)}
              category_name={test.category_name}
              mrp_price={test.mrp_price}
            />
          ))}
        </div>

        <div className="mt-8 text-center">
          <Link to="/book-tests">
          <button className="px-6 py-2 border border-[#951C25] rounded-full text-sm font-medium text-[#951C25] hover:bg-[#951C25] hover:text-white transition-colors">
            View All Tests
          </button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default PopularTests;
